"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _UnknownTooltip = _interopRequireDefault(require("./UnknownTooltip"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function HeldLicenseTransfer(row) {
  var sourceEntity = (0, _get2["default"])(row, 'sourceEntity');
  var targetEntity = (0, _get2["default"])(row, 'targetEntity');
  var quantity = (0, _get2["default"])(row, 'quantity');
  if (targetEntity && sourceEntity) {
    if (quantity !== null) {
      return /*#__PURE__*/_react["default"].createElement("span", null, "Transferred ", quantity, " license", quantity === 1 ? '' : 's', " from ", /*#__PURE__*/_react["default"].createElement("b", null, sourceEntity), " to", ' ', /*#__PURE__*/_react["default"].createElement("b", null, targetEntity));
    }
    return /*#__PURE__*/_react["default"].createElement("span", null, "Transferred licenses from ", /*#__PURE__*/_react["default"].createElement("b", null, sourceEntity), " to ", /*#__PURE__*/_react["default"].createElement("b", null, targetEntity));
  }
  if (targetEntity) {
    if (quantity !== null) {
      return /*#__PURE__*/_react["default"].createElement("span", null, "Transferred ", quantity, " license", quantity === 1 ? '' : 's', " from an unknown group to", ' ', /*#__PURE__*/_react["default"].createElement("b", null, targetEntity), /*#__PURE__*/_react["default"].createElement(_UnknownTooltip["default"], {
        type: "Group"
      }));
    }
    return /*#__PURE__*/_react["default"].createElement("span", null, "Transferred licenses from an unknown group to ", /*#__PURE__*/_react["default"].createElement("b", null, targetEntity), /*#__PURE__*/_react["default"].createElement(_UnknownTooltip["default"], {
      type: "Group"
    }));
  }
  if (sourceEntity) {
    if (quantity !== null) {
      return /*#__PURE__*/_react["default"].createElement("span", null, "Transferred ", quantity, " license", quantity === 1 ? '' : 's', " from ", /*#__PURE__*/_react["default"].createElement("b", null, sourceEntity), " to an unknown group", /*#__PURE__*/_react["default"].createElement(_UnknownTooltip["default"], {
        type: "Group"
      }));
    }
    return /*#__PURE__*/_react["default"].createElement("span", null, "Transferred licenses from ", /*#__PURE__*/_react["default"].createElement("b", null, sourceEntity), " to an unknown group", /*#__PURE__*/_react["default"].createElement(_UnknownTooltip["default"], {
      type: "Group"
    }));
  }
  if (quantity !== null) {
    return /*#__PURE__*/_react["default"].createElement("span", null, "Transferred ", quantity, " license", quantity === 1 ? '' : 's', " between two unknown groups", /*#__PURE__*/_react["default"].createElement(_UnknownTooltip["default"], {
      type: "Group"
    }));
  }
  return /*#__PURE__*/_react["default"].createElement("span", null, "Transferred licenses between two unknown groups", /*#__PURE__*/_react["default"].createElement(_UnknownTooltip["default"], {
    type: "Group"
  }));
}
var _default = exports["default"] = HeldLicenseTransfer;